import type { PastAttempt } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import { useRouter } from "next/compat/router";
import useSWRImmutable from "swr/immutable";

const useFinalExamAttempts = () => {
	const { slug } = (useRouter()?.query ?? {}) as {
		slug: string;
	};

	const { userId } = useAuth();

	return useSWRImmutable<{
		pastAttempts: PastAttempt[];
		remainingAttempts: number;
		unlockDate?: string;
	}>(slug && userId && `/courses/${slug}/exams/final/attempts`);
};

export default useFinalExamAttempts;
